const helpers = {

  // Convert Temperature from Celsius to Fahrenheit
  convertTemperature(temperature) {

    if (!temperature || temperature === 'N/A') return 'N/A'

    let celsius = Math.round(temperature)
    let fahrenheit = Math.round(temperature * 1.8 + 32)
    
    return {
        fahrenheit: fahrenheit,
        celsius: celsius
    }

  },

  // Convert Speed from ms^-1 to mph
  convertMsToMph(spd) {

    let speed
    if (spd) {
      speed = `${Math.round(spd * 2.236936)} mph`
    } else if (spd === 0) {
      speed = 'Calm'
    } else {
      speed = ' '
    }

    return speed

  },

  // Convert Wind Direction from degrees to 8-point compass rose
  convertDirection(wDir) {
    let direction
    if (wDir >0 && wDir <=22) {
        direction = { long: 'North', short: 'N' }
    }
    else if (wDir >22 && wDir <=67) {
        direction = { long: 'Northeast', short: 'NE' }
    }
    else if (wDir >67 && wDir <=112) {
        direction = { long: 'East', short: 'E' }
    }
    else if (wDir >112 && wDir <=157) {
        direction = { long: 'Southeast', short: 'SE' }
    }
    else if (wDir >157 && wDir <=202) {
        direction = { long: 'South', short: 'S' }
    }
    else if (wDir >202 && wDir <=247) {
        direction = { long: 'Southwest', short: 'SW' }
    }
    else if (wDir >247 && wDir <=292) {
        direction = { long: 'West', short: 'W' }
    }
    else if (wDir >292 && wDir <=337) {
        direction = { long: 'Northwest', short: 'NW' }
    }
    else if (wDir >337 && wDir <=360) {
        direction = { long: 'North', short: 'N' }
    }
    else if (wDir === 0) {
        direction = { long: ' ', short: ' ' }
    }
    else if (wDir === -1) {
        direction = { long: 'Variable', short: 'Var'}
    }
    else if (wDir === null) {
        direction = { long: ' ', short: ' ' }
    }
    else {
        direction = { long: ' ', short: ' ' }
    }
    return direction
  },

  convertHpaToInches(pressure) {
    return pressure * 0.02953
  },

  // Convert ISO8601 to Time
  convertToTime(fullDate) {

    if (!fullDate || fullDate === 'N/A') return 'N/A' 

    const militaryHour = new Date(fullDate).getHours()
    const mins = new Date(fullDate).getMinutes() < 10 ? '0' + new Date(fullDate).getMinutes() : new Date(fullDate).getMinutes()
  
    let hour
    if (militaryHour >= 13 && militaryHour <= 23) {
      hour = militaryHour - 12
    } else if (militaryHour === 0 || militaryHour === 12) {
      hour = 12
    } else if (militaryHour >=1 && militaryHour <= 11) {
      hour = militaryHour
    } else {
      hour = 'Unknown'
    }
  
    let amOrPm
    if (militaryHour >= 0 && militaryHour <= 11) {
      amOrPm = ' AM'
    } else if (militaryHour >= 12 && militaryHour <= 23) {
      amOrPm = ' PM'
    } else {
      amOrPm = 'Unknown'
    }
  
    return {
      withMins: `${hour}:${mins} ${amOrPm}`,
      withoutMins: `${hour} ${amOrPm}`
    }
  },

  convertToDayOfWeek(fullDate) {

    if (!fullDate || fullDate === 'N/A') return 'N/A' 

    const day = new Date(fullDate).getDay();
  
    let dayOfWeek;
  
    if (day === 0) { 
      dayOfWeek = { long: 'Sunday', short: 'Sun' } 
    }
    else if (day === 1) { 
      dayOfWeek = { long: 'Monday', short: 'Mon' } 
    }
    else if (day === 2) { 
      dayOfWeek = { long: 'Tuesday', short: 'Tue' } 
    }
    else if (day === 3) { 
      dayOfWeek = { long: 'Wednesday', short: 'Wed' } 
    }
    else if (day === 4) { 
      dayOfWeek = { long: 'Thursday', short: 'Thu' }
    }
    else if (day === 5) { 
      dayOfWeek = { long: 'Friday', short: 'Fri' } 
    }
    else if (day === 6) { 
      dayOfWeek = { long: 'Saturday', short: 'Sat' } 
    }
    else { 
      dayOfWeek = { long: 'Unknown', short: 'Null' }
    }
  
    return dayOfWeek
  },

  // Return phrase as mixed case. 
  // Ex: GAINESVILLE REGIONAL AIRPORT becomes Gainesville Regional Airport
  convertToMixedCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  },

  // Icons
  getMetarIcon(value, isDaylight) {
    const icon_base_url = 'https://pbsweather.org/wp-content/uploads/wxicons';

    // Return blank image if no weather icon ID is available
    if (value === 'N/A') return 'https://pbsweather.org/wp-content/uploads/blank.png'

    if (isDaylight) {
      return `${icon_base_url}/${value}.png`;
    } else {
      return `${icon_base_url}/${value}-night.png`
    }
  },

}

export default helpers